import type { CollapsibleRootProps } from '@base-ui/react';
import type { ReactNode } from 'react';

import { Collapsible as BaseCollapsible } from '@base-ui/react';
import { useRef } from 'react';

import { panelStyle } from './Collapsible.css';

type Props = Omit<CollapsibleRootProps, 'children' | 'defaultOpen' | 'open' | 'render'> & {
  children: ReactNode;
};

export const Collapsible = ({ children, ...delegated }: Props) => {
  const open = Boolean(children);

  const lastChildrenRef = useRef<ReactNode>(null);

  if (open) lastChildrenRef.current = children;

  return (
    <BaseCollapsible.Root
      {...delegated}
      open={open}
      // Leave no element behind while closed, so parent `:last-child` selectors and flex/grid gaps aren't affected.
      // `transitionStatus` is only `undefined` once the panel has unmounted after its exit transition.
      render={(props, state) => (state.open || state.transitionStatus !== undefined ? <div {...props} /> : <></>)}
    >
      <BaseCollapsible.Panel className={panelStyle}>{open ? children : lastChildrenRef.current}</BaseCollapsible.Panel>
    </BaseCollapsible.Root>
  );
};
